import { companyIdState } from '../company.state';
import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '@/config/query-client';
import { fetchCompanyRatings } from '@/api/v4/organization-ratings.api';
import { fetchSpotlightCompanyRatings } from '@/api/v4/spotlight.api';
import { useAtomValue } from 'jotai';
import {
  type CompanyFetchMode,
  useCompanyFetchMode,
} from '../company-fetch-context';

const companyRatingsFetchers: Record<
  CompanyFetchMode,
  (companyId: string) => ReturnType<typeof fetchCompanyRatings>
> = {
  general: fetchCompanyRatings,
  spotlight: fetchSpotlightCompanyRatings,
};

export const useCompanyRankings = () => {
  const companyId = useAtomValue(companyIdState);
  const fetchMode = useCompanyFetchMode();

  return useQuery({
    queryKey: [QueryKey.CompanyRankings, fetchMode, companyId],
    queryFn: () => {
      if (!companyId) return undefined;
      return companyRatingsFetchers[fetchMode](companyId);
    },
    enabled: !!companyId,
  });
};
